import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './BrandCard.styles';
const BrandCard = (props) => {
    const srcs = props.type === 'image' && props.image
        ? getSrcs(props.image, 706, 170, 8, 259 / 146, { rmode: 'pad' })
        : undefined;
    return (React.createElement(S.Container, { "data-variant": props.variant, ...(props.cta
            ? {
                as: 'a',
                href: props.cta.url,
                target: props.cta.target,
                'aria-label': props.imageOnly ? props.heading : undefined,
            }
            : {}) },
        React.createElement(S.ImageContainer, null,
            props.type === 'image' && srcs && (React.createElement(S.Image, { src: srcs.src, srcSet: srcs.srcSet, sizes: props.sizes, alt: props.image.altText, loading: "lazy" })),
            props.type === 'icon' && React.createElement(React.Fragment, null, getSvgIcon(props.icon))),
        !props.imageOnly ? (React.createElement(S.ContentWrapper, null,
            React.createElement(S.Heading, { as: props.headingType }, props.heading),
            props.subheading && React.createElement(S.Subheading, null, props.subheading),
            props.cta && (React.createElement(FakeButton, { buttonType: "secondary", icon: InterfaceIcon.ArrowRight, iconOnly: true })))) : null));
};
export default BrandCard;
